import React from "react";
import "../components/css/style.css";
import "../components/css/legal.css";
import BreadcrumbIllustration from "../assets/imgs/img_banner.png";

export default function PrivacyPolicySection() {
    const handleHomeClick = (e) => {
        e.preventDefault();
        window.location.href = "/";
    };

    return (
        <div className="abt-section">
            <div className="abt-container">
                <div className="abt-left">
                    <h1 className="abt-title">
                        <span className="abt-highlight">Privacy Policy</span>
                    </h1>

                    <div className="abt-breadcrumb">
                        <span className="abt-crumb abt-home" onClick={handleHomeClick}>Home</span>
                        <span className="abt-crumb abt-active">Privacy Policy</span>
                    </div>
                </div>

                <div className="abt-right">
                    <div className="abt-image-wrapper">
                        <img
                        src={BreadcrumbIllustration}
                        alt="Illustration"
                        className="abt-image"
                        />
                    </div>
                    <div className="abt-glow"></div>
                    <div className="abt-glow abt-glow-second"></div>
                </div>
            </div>

            <section className="pp-section">
                <div className="pp-container">
                    <div className="pp-content">
                        <p>
                            At RhythmGrowthLab, we respect your privacy and are committed to protecting your personal and business information. This Privacy Policy explains how we collect, use, store, and safeguard your data when you engage with our services, website, or communication channels.
                        </p>

                        <h2>1. Information We Collect</h2>
                        <p>We may collect the following information:</p>
                        <p><strong>Personal Information</strong></p>
                        <ul>
                            <li>Full Name</li>
                            <li>Email Address</li>
                            <li>Phone Number</li>
                            <li>Business / Company Name</li>
                            <li>Billing & Payment Details</li>
                            <li>Address (if required for invoicing)</li>
                            <li>Any information voluntarily shared through forms, consultations, WhatsApp, calls, or emails</li>
                        </ul>
                        <p><strong>Technical Information</strong></p>
                        <ul>
                            <li>IP Address</li>
                            <li>Browser Type</li>
                            <li>Device Information</li>
                            <li>Website Usage Data</li>
                            <li>Cookies & Analytics Data</li>
                        </ul>

                        <h2>2. How We Use Your Information</h2>
                        <p>Your information may be used for the following purposes:</p>
                        <ul>
                            <li>To provide our services including Website Development, Mobile App Development, Branding, Digital Marketing, and Performance Marketing</li>
                            <li>To process invoices and payments</li>
                            <li>To communicate regarding projects, updates, revisions, and support</li>
                            <li>To improve our website, systems, and customer experience</li>
                            <li>To send service proposals, updates, offers, or notices</li>
                            <li>To maintain records and internal business operations</li>
                            <li>To comply with legal obligations</li>
                        </ul>

                        <h2>3. Payment Information</h2>
                        <p>
                            Upon receipt of an invoice from RhythmGrowthLab, all payments must be made only through officially shared payment methods such as:
                        </p>
                        <ul>
                            <li>UPI</li>
                            <li>Razorpay</li>
                            <li>Payoneer</li>
                            <li>PayPal</li>
                            <li>Any officially approved business payment method</li>
                        </ul>
                        <p>Payments made to any unauthorized or third-party account shall not be considered valid.</p>
                        <p>
                            All fees paid for services are non-refundable and non-transferable, including but not limited to:
                        </p>
                        <ul>
                            <li>Website Development</li>
                            <li>Mobile App Development (Android & iOS)</li>
                            <li>Brand Identity Design</li>
                            <li>Digital Marketing</li>
                            <li>Performance Marketing (Meta / Google Ads)</li>
                        </ul>
                        <p>
                            Once a project or service has commenced, refund requests, cancellations, chargebacks, reversals, or partial payment disputes shall not be entertained.
                        </p>

                        <h2>4. Website Revisions & Post-Finalization Changes</h2>
                        <p>
                            For any website project, a maximum of <strong>6–7 changes</strong> (revisions) are included and accepted within the agreed scope of work.
                        </p>
                        <p>
                            Any additional changes beyond the included 6–7 revisions will be charged at <strong>Rs 1,200 per change</strong>.
                        </p>
                        <p>
                            Once the website is finalized and completed, any further changes requested by the client — whether after one week, one month, or several months — will be charged at <strong>Rs 1,600 per change</strong>.
                        </p>
                        <p>
                            If the website is fully completed but <strong>1–2 minor items remain pending</strong>, and the client fails to provide the required content, assets, information, or approvals within <strong>8–10 days</strong> of being requested, the website shall be considered <strong>fully completed and delivered</strong>. Any changes, additions, or modifications requested thereafter will be charged at <strong>Rs 1,600 per change</strong>.
                        </p>
                        <p>
                            All revision and post-finalization change charges must be paid in full before any further work, updates, or modifications are carried out on the finalized website.
                        </p>

                        <h2>5. Website Redesign</h2>
                        <p>
                            If a client requests a complete website redesign after the project has been finalized and delivered, the <strong>full payment of the website</strong> will be charged again.
                        </p>
                        <p>
                            A request to change the <strong>color theme</strong> of the website shall also be considered as a website redesign and will be charged at the full website cost.
                        </p>
                        <p>
                            Website redesign charges must be paid in full before any redesign work is initiated.
                        </p>

                        <h2>6. Data Protection & Security</h2>
                        <p>
                            We implement appropriate technical and organizational safeguards to protect your data against unauthorized access, misuse, alteration, or disclosure.
                        </p>
                        <p>
                            However, no online system can guarantee 100% security. By using our services, you acknowledge this inherent risk.
                        </p>

                        <h2>7. Sharing of Information</h2>
                        <p>
                            We do not sell, rent, or trade your personal information.
                        </p>
                        <p>
                            We may share information only with:
                        </p>
                        <ul>
                            <li>Trusted payment processors</li>
                            <li>Software/service providers assisting project delivery</li>
                            <li>Legal authorities when required by law</li>
                            <li>Team members directly involved in project execution</li>
                        </ul>

                        <h2>8. Client Responsibility & Compliance Disclaimer</h2>
                        <p>
                            RhythmGrowthLab provides services based solely on client-provided information, materials, approvals, and instructions.
                        </p>
                        <p>The client is solely responsible for ensuring:</p>
                        <ul>
                            <li>Accuracy of submitted information</li>
                            <li>Ownership or rights to all content, logos, trademarks, creatives, media, and materials provided</li>
                            <li>Compliance with Meta, Google, App Store, Play Store, and all third-party platform policies</li>
                            <li>Compliance with all applicable laws, regulations, and advertising standards</li>
                        </ul>
                        <p>
                            RhythmGrowthLab, its owner, team, or affiliates shall not be liable for:
                        </p>
                        <ul>
                            <li>Ad account bans, suspensions, restrictions, or policy actions</li>
                            <li>Website or app rejection by platforms</li>
                            <li>Copyright or trademark disputes</li>
                            <li>Legal claims arising from client-provided content</li>
                            <li>Business loss, revenue loss, or damages resulting from campaigns or deliverables</li>
                        </ul>
                        <p>Full responsibility remains solely with the client.</p>

                        <h2>9. Cookies Policy</h2>
                        <p>
                            Our website may use cookies to:
                        </p>
                        <ul>
                            <li>Improve browsing experience</li>
                            <li>Analyze website traffic</li>
                            <li>Store preferences</li>
                            <li>Enhance marketing performance</li>
                        </ul>
                        <p>You may disable cookies in your browser settings.</p>

                        <h2>10. Third-Party Links</h2>
                        <p>
                            Our website or communications may include links to third-party platforms or websites. We are not responsible for their privacy practices, policies, or content.
                        </p>

                        <h2>11. Confidentiality</h2>
                        <p>
                            Client information, business data, and project details are treated confidentially.
                        </p>
                        <p>
                            We may use non-sensitive results, anonymous performance data, or completed project samples for portfolio, case study, or internal analysis purposes unless objected to in writing.
                        </p>

                        <h2>12. Governing Law</h2>
                        <p>
                            This Privacy Policy and all related services shall be governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Delhi, India.
                        </p>

                        <h2>13. Policy Updates</h2>
                        <p>
                            RhythmGrowthLab reserves the right to modify or update this Privacy Policy at any time. Changes will be published on this page with an updated effective date.
                        </p>

                        <h2>14. Contact Us</h2>
                        <p>
                            If you have any questions about this Privacy Policy, please contact us at:<br />
                            <strong>Email:</strong> info@rhythmgrowthlab.com
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}